import styled from 'styled-components'

export const Container = styled.div`
  border: 1px solid #ff4d4f;
  border-left: 4px solid #ff4d4f;
  border-radius: 8px;
  padding: 16px 20px;
  margin: 12px 0;
  background-color: #fff5f5;
  box-shadow: 0 2px 4px rgba(255, 77, 79, 0.1);
`

export const Title = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 16px;
  letter-spacing: 0.02em;
`

export const ReasonList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

export const ReasonItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  padding: 8px 0;
  font-size: 13px;
  line-height: 1.5;
  
  &:last-child {
    margin-bottom: 0;
  }
`

export const Circle = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  min-width: 20px;
  border-radius: 50%;
  background-color: #fff;
  border: 1px solid #ff4d4f;
  color: #ff4d4f;
  text-align: center;
  line-height: 18px;
  margin-right: 10px;
  font-size: 12px;
`

export const ReasonText = styled.span`
  margin-left: 12px;
  flex: 1;
  color: #595959;
  line-height: 1.6;
  font-size: 13px;
  
  span {
    font-weight: 600;
    color: #262626;
  }
`